/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Faq_2_AnswerInputs */

const en_svc_integration_faq_2_answer = /** @type {(inputs: Svc_Integration_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We choose per task: commercial models from providers such as OpenAI, Anthropic or Google, or open models where your data rules call for them. The integration is built so the model can be swapped later.`)
};

const lv_svc_integration_faq_2_answer = /** @type {(inputs: Svc_Integration_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izvēlamies katram uzdevumam: komerciālus modeļus no tādiem piegādātājiem kā OpenAI, Anthropic vai Google, vai atvērtos modeļus, ja to prasa Jūsu datu noteikumi. Integrācija veidota tā, lai modeli vēlāk varētu nomainīt.`)
};

/**
* | output |
* | --- |
* | "We choose per task: commercial models from providers such as OpenAI, Anthropic or Google, or open models where your data rules call for them. The integration..." |
*
* @param {Svc_Integration_Faq_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_faq_2_answer = /** @type {((inputs?: Svc_Integration_Faq_2_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Faq_2_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_faq_2_answer(inputs)
	return en_svc_integration_faq_2_answer(inputs)
});